
import { Vue, Component, Prop } from "vue-property-decorator";
import textEditor from "./text-editor.vue";
import uploadFile from "./uploadFile.vue";
import javaUploadFile from "./javaUploadFile.vue";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "comDetails",
  components: {
    textEditor,
    uploadFile,
    javaUploadFile
  }
})
export default class comDetails extends BaseVue {
  @Prop({ default: () => [] }) Details!: Object; //详情数据
  @Prop({ default: 100 }) labelWidth!: any; //详情数据
  
  mounted(){
  }

}
